import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Stats from './components/Stats';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Legal from './pages/Legal';
import Announcement from './pages/Announcement';
import './App.css';

const helmetContext = {};

function App() {
  return (
    <HelmetProvider context={helmetContext}>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/announcement" element={<Announcement />} />
            <Route
              path="/"
              element={
                <>
                  <Helmet>
                    <title>Premium SMM Panel - Professional Social Media Marketing Services</title>
                    <meta
                      name="description"
                      content="Boost your social media presence with Premium SMM Panel. Get high-quality followers, likes, and engagement for all major platforms. Fast delivery and 24/7 support."
                    />
                  </Helmet>
                  <Navbar />
                  <Hero />
                  <Stats />
                  <Services />
                  <Features />
                  <Pricing />
                  <Testimonials />
                  <FAQ />
                  <Footer />
                </>
              }
            />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;